<template>
	<div class="height-100dvh">
		<NcdTopContainer v-if="isMobile" />
		<main class="interview-kick-container">
			<div id="hideinmobile" class="cand-header d-flex mb-2">
				<!-- <img
					class="mr-3 d-flex pointer"
					src="../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
					@click="goback()"
				/> -->
				Prepare for an Interview
			</div>
			<div class="inki-container">
				<article>
					<div class="pt-4 px-4">
						<div class="text-blue fs-24 mob-fs-16 fw-B fam-mont">
							Prepare By Skill
						</div>
						<div class="text-darkgrey fs-20 mob-fs-14 fw-LM fam-lato inki-mt-3">
							Strengthen your capabilities with focused, skill-specific
							interview preparation.
						</div>
						<b-button
							class="candash-addBtn inki-mt-4"
							@click="navigateToSkills('byskill')"
						>
							Prepare Now
						</b-button>
					</div>
					<div class="w-100 d-flex justify-content-center image">
						<img src="../../assets/img/prepInterview/bySkill.svg" alt="" />
					</div>
				</article>
				<article>
					<div class="pt-4 px-4">
						<div class="text-blue fs-24 mob-fs-16 fw-B fam-mont">
							Prepare By Company/Role
						</div>
						<div class="text-darkgrey fs-20 mob-fs-14 fw-LM fam-lato inki-mt-3">
							Prepare smarter with questions tailored to your target companies
							and job roles.
						</div>
						<b-button
							class="candash-addBtn inki-mt-4"
							@click="navigateToSkills('bycompany')"
						>
							Prepare Now
						</b-button>
					</div>
					<div class="w-100 d-flex justify-content-center image">
						<img src="../../assets/img/prepInterview/byCompany.svg" alt="" />
					</div>
				</article>
			</div>
			<article class="reports-section-card pt-4 px-4 pb-4">
				<div
					class="reports-title text-blue fs-24 mob-fs-16 fw-B fam-mont pointer"
					@click="showInterruptedModal = true"
				>
					Reports
				</div>
				<div
					class="reports-desc text-darkgrey fs-20 mob-fs-14 fw-LM fam-lato inki-mt-3"
				>
					Learn practical, in-demand skills to stay ahead in your career
					journey.
				</div>
				<b-button
					class="candash-addBtn reports-btn inki-mt-4"
					@click="navigateToReports()"
				>
					View Reports
				</b-button>
				<div class="reports-image" style="position: relative">
					<img src="../../assets/img/homepage/reports-section.svg" alt="" />
				</div>
			</article>
		</main>
		<InterruptedInterviewModal
			:showModal.sync="showInterruptedModal"
			@end="onEndInterview"
			@resume="onResumeInterview"
		/>
		<NcdBottomContainer v-if="isMobile" />
		<InterviewPrepModal
			v-if="interviewPrepModal"
			:showMod="interviewPrepModal"
			:fromAnotherPage="true"
			@close-modal="hidePrepModal()"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import InterruptedInterviewModal from "@/components/modal/InterruptedInterviewModal.vue";
import InterviewPrepModal from "@/components/MyProfile/NoskillPrepareInterview.vue";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import NcdBottomContainer from "@/components/NewCandidateDashboard/NcdBottomContainer.vue";

export default {
	components: {
		InterruptedInterviewModal,
		InterviewPrepModal,
		NcdTopContainer,
		NcdBottomContainer,
	},
	data() {
		return {
			showInterruptedModal: false,
			interviewPrepModal: false,
			isMobile: false,
		};
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateData: "getPrimaryCandidateInfo",
		}),
	},
	mounted() {
		this.checkScreenSize();
		window.addEventListener("resize", this.checkScreenSize);
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize);
	},
	methods: {
		checkScreenSize() {
			this.isMobile = window.innerWidth < 1028;
		},
		navigateToSkills(type) {
			if (type === "byskill") {
				const OnlySkills = (this.candidateData.skills || []).filter(
					(link) => link.parser != true
				);
				if (OnlySkills.length === 0) {
					this.interviewPrepModal = true;
					return;
				}
			}
			this.$router.push({
				name: "InterviewSkills",
				query: { ...this.$route.query, [type]: true, from: "kickstart" },
			});
		},
		hidePrepModal() {
			this.interviewPrepModal = false;
		},
		navigateToReports() {
			this.$router.push({
				name: "ReportAiInterview",
				query: { ...this.$route.query, from: "kickstart" },
			});
		},
		goback() {
			if (this.$route.query.from === "home") {
				this.$router.push({ name: "Homepage" });
			} else {
				this.$router.push({ name: "CandidateDashboard" });
			}
		},
		onEndInterview() {
			console.log("End Interview clicked");
		},
		onResumeInterview() {
			console.log("Resume Interview clicked");
		},
	},
};
</script>

<style>
.interview-kick-container {
	background-color: #e9ecef;
	height: calc(100vh - 60px);
	padding: 15px 15px 15px 75px;
	top: 60px;
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	overflow-y: auto;
}
.interview-kick-container .cand-header {
	background-color: #20639b14;
}
.inki-container {
	display: flex;
	gap: 20px;
	margin-top: 10px;
	flex: 1.5;
	min-height: 380px;
	width: 100%;
	max-width: 1825px;
}
.inki-mt-3 {
	margin-top: 15px;
}
.inki-mt-4 {
	margin-top: 20px;
}
.inki-container article {
	border: 1px solid #20639b33;
	box-shadow: 0px 4px 30px 0px #3629b712;
	background-color: #fff;
	border-radius: 16px;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.inki-container .image {
	height: calc(100% - 200px);
}
.inki-container article img {
	width: 90%;
}
.inki-container .btn {
	width: 200px;
}
.reports-section-card {
	border: 1px solid #20639b33;
	box-shadow: 0px 4px 30px 0px #3629b712;
	background-color: #fff;
	border-radius: 16px;
	width: 100%;
	max-width: 1825px;
	margin-top: 20px;
	display: grid;
	grid-template-areas:
		"title image"
		"desc  image"
		"btn   image";
	grid-template-columns: 1.2fr 0.8fr;
	grid-template-rows: auto auto 1fr;
	align-items: start;
	flex: 1;
	min-height: 200px;
	padding: 12px 0 12px 24px;
	overflow: hidden;
	padding-bottom: 0px !important;
}
.reports-title {
	grid-area: title;
}
.reports-desc {
	grid-area: desc;
}
.reports-btn {
	grid-area: btn;
	width: 200px;
}
.reports-image {
	grid-area: image;
	height: 100%;
	align-self: stretch;
	display: flex;
	align-items: flex-end;
	justify-content: flex-end;
}
.reports-image img {
	height: 100%;
	max-height: 100%;
	max-width: 100%;
	object-fit: contain;
}
@media (max-width: 1028px) {
	.interview-kick-container {
		background-color: #e9ecef;
		height: calc(
			100dvh -
				(60px + env(safe-area-inset-top) + 58px + env(safe-area-inset-bottom))
		) !important;
		padding: 15px !important;
		overflow: auto !important;
		position: fixed !important;
		top: calc(60px + env(safe-area-inset-top)) !important;
		display: unset !important;
	}
	.inki-container {
		flex-direction: column;
		margin-top: unset;
		height: auto;
		overflow: visible;
	}
	.inki-mt-3 {
		margin-top: 5px;
	}
	.inki-mt-4 {
		margin-top: 15px;
	}
	.inki-container .image {
		height: unset;
		margin-top: 10px;
	}
	.reports-section-card {
		flex: unset;
		height: 152px;
		margin-top: 15px;
		padding: 16px;
		display: grid;
		grid-template-areas:
			"title title"
			"desc  desc"
			"btn   image";
		grid-template-columns: auto 1fr;
		grid-template-rows: auto auto 1fr;
		align-items: center;
		padding-bottom: 0px !important;
	}
	.reports-title {
		grid-area: title;
	}
	.reports-desc {
		grid-area: desc;
		width: 100%;
	}
	.reports-btn {
		grid-area: btn;
		width: 135px;
	}
	.reports-image {
		grid-area: image;
		width: 100%;
		height: auto;
		display: flex;
		align-items: flex-end;
		justify-content: flex-end;
		position: relative;
		bottom: 0px;
	}
	.reports-image img {
		width: 100%;
		max-width: 240px;
		height: auto;
	}
}
</style>
